module.exports = __webpack_public_path__ + "img/wtb8.d7e28f72.png";